import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

async function saveGroupMenu(data) {
    try {
        return await needAuth(`/groupmenus`, data)
    } catch (error) {
        if (error instanceof AxiosError) {
            const data = error.response.data;
            const status = error.response.status;
            return {data, status};
        }
    }
}

async function selectGroupMenus(userGroupId) {
    try {
        return await needAuth(`/groupmenus/${userGroupId}`)
    } catch (error) {
        if (error instanceof AxiosError) {
            const data = error.response.data;
            const status = error.response.status;
            return {data, status};
        }
    }
}

async function deleteGroupMenu(data) {
    try {
        return await needAuth(`/groupmenus`, data)
    } catch (error) {
        if (error instanceof AxiosError) {
            const data = error.response.data;
            const status = error.response.status;
            return {data, status};
        }
    }
}

export {saveGroupMenu, selectGroupMenus, deleteGroupMenu}